import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockResetRoundedIcon from "@mui/icons-material/LockResetRounded";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import { Box, Button, InputAdornment, Paper, TextField, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { NavLink } from "react-router-dom";
import SimpleBackdrop from "./BackDrop";
import "./auth-modern.css";

function ForgotPassword() {
  const [sentOtp, setSentOtp] = useState("");
  const [otp, setValue] = useState("");
  const [err, setErr] = useState("");
  const [next1, setNext1] = useState(false);
  const [password, setPassword] = useState("");
  const [next, setNext] = useState(false);
  const [next2, setNext2] = useState(false);

  React.useLayoutEffect(() => {
    const moveToTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    moveToTop();
    const frame = window.requestAnimationFrame(moveToTop);
    const timer = window.setTimeout(moveToTop, 120);

    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(timer);
    };
  }, []);

  const handleChange = (event) => {
    console.log(event);
    setValue(event);
  };
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const [email, setEmail] = useState("");
  const handleSubmit = () => {
    if (otp.toString() === sentOtp.toString()) {
      setNext1(true);
    }
  };
  const updatePassword = () => {
    setOpen(true);
    axios
      .put(
        `${process.env.React_APP_BACKEND_URL}/api/updatepassword`,
        {
          password,
          email,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      )
      .then((res) => {
        setOpen(false);
        setNext2(true);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const sentEmail = () => {
    setOpen(true);

    axios
      .post(
        `${process.env.React_APP_BACKEND_URL}/api/forgot`,
        { email: email },
        { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
      )
      .then((res) => {
        console.log(res);
        setOpen(false);
        setSentOtp(res.data.otp);
        setNext(true);
      })
      .catch((err) => {
        setOpen(false);
        setErr("Email does not exist");
        console.log(err);
      });
  };
  return (
    <Box
      id="bidit-auth-top"
      className="auth-modern-forgot"
      dir="rtl"
      sx={{
        fontFamily: `${process.env.REACT_APP_FONT}`,
        minHeight: "calc(100vh - 70px)",
        px: 2,
        py: { xs: 4, md: 7 },
        background: "radial-gradient(circle at 84% 4%, rgba(8,119,201,.18), transparent 31%), radial-gradient(circle at 10% 92%, rgba(43,190,153,.12), transparent 27%), linear-gradient(180deg, #eef8ff 0%, #f8fcff 52%, #ffffff 100%)",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 510,
          mx: "auto",
          p: { xs: 2.5, sm: 4 },
          borderRadius: 4,
          border: "1px solid rgba(8,119,201,.16)",
          bgcolor: "rgba(255,255,255,.97)",
          boxShadow: "0 24px 65px rgba(20,80,128,.16)",
          textAlign: "center",
          fontFamily: "inherit",
        }}
      >
      {!next && (
        <Box>
          <Box sx={{ width: 68, height: 68, mx: "auto", mb: 2, borderRadius: "20px", display: "grid", placeItems: "center", color: "#fff", background: "linear-gradient(135deg, #0877c9, #21b4d8)", boxShadow: "0 12px 28px rgba(8,119,201,.24)" }}>
            <LockResetRoundedIcon sx={{ fontSize: 34 }} />
          </Box>
          <Typography
            component="h1"
            sx={{ fontFamily: "inherit", fontWeight: 900, color: "#17394d", fontSize: { xs: "1.55rem", sm: "1.85rem" }, mb: 0.8 }}
          >
            שחזור הגישה לחשבון
          </Typography>
          <Typography sx={{ color: "#647b8a", lineHeight: 1.7, mb: 2.2, fontSize: "1rem" }}>
            הזן את כתובת הדוא"ל שאיתה נרשמת, ונשלח אליך קוד קצר לאימות.
          </Typography>
          <TextField
            margin="normal"
            required
            sx={{ fontFamily: "inherit", "& .MuiOutlinedInput-root": { borderRadius: 3, bgcolor: "#fbfdff" } }}
            fullWidth
            id="email"
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
            label="כתובת דוא״ל"
            name="email"
            autoComplete="email"
            InputProps={{ startAdornment: <InputAdornment position="start"><EmailOutlinedIcon sx={{ color: "#6f8795" }} /></InputAdornment> }}
            //autoFocus
          />
          <Typography sx={{ color: "#738895", textAlign: "right", mt: 0.2, mb: 1, fontSize: ".9rem" }}>
            קוד לאימות יישלח לכתובת הדוא״ל הרשומה שלך.
          </Typography>
          {err && (
            <Typography sx={{ color: "#c62828", textAlign: "right", mt: 0.5, mb: 1, fontWeight: 700, fontSize: ".92rem" }}>
              כתובת הדוא"ל לא מוכרת
            </Typography>
          )}
          <Button
            variant="contained"
            endIcon={<ArrowBackRoundedIcon />}
            sx={{ fontFamily: "inherit", width: "100%", mt: 1.2, py: 1.35, borderRadius: 3, fontWeight: 900, fontSize: "1.02rem", background: "linear-gradient(90deg, #0877c9, #109ad7)", boxShadow: "0 9px 22px rgba(8,119,201,.22)" }}
            onClick={sentEmail}
          >
            שלחו לי קוד אימות
          </Button>
        </Box>
      )}
      {next && !next1 && (
        <Box>
          <Box sx={{ width: 62, height: 62, mx: "auto", mb: 2, borderRadius: "50%", display: "grid", placeItems: "center", color: "#0877c9", bgcolor: "#eaf7ff" }}>
            <VerifiedUserOutlinedIcon sx={{ fontSize: 33 }} />
          </Box>
          <Typography
            component="h1"
            sx={{ fontFamily: "inherit", fontWeight: 900, color: "#17394d", fontSize: { xs: "1.5rem", sm: "1.8rem" } }}
          >
            הקוד בדרך אליך
          </Typography>
          <Typography sx={{ color: "#647b8a", mt: 0.7, mb: 2 }}>הזן את 6 הספרות שנשלחו לתיבת הדוא״ל שלך.</Typography>
          <Box dir="ltr">
            <OtpInput
              containerStyle={{
                width: "100%",
                marginTop: "10px",
                marginBottom: "10px",
                textAlign: "center",
              }}
              inputStyle={{
                width: "100%",
                height: "48px",
                color: "black",
                fontWeight: 800,
                fontSize: "1.15rem",
                border: "1px solid #cbdde8",
                borderRadius: "10px",
                margin: "0 3px",
              }}
              value={otp}
              onChange={handleChange}
              numInputs={6}
              separator={<span>-</span>}
            />
          </Box>
          <Button variant="contained" fullWidth onClick={handleSubmit} sx={{ mt: 1, py: 1.3, borderRadius: 3, fontWeight: 900 }}>
            אימות הקוד
          </Button>
        </Box>
      )}
      {next1 && !next2 && (
        <Box sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
          <Box sx={{ width: 62, height: 62, mx: "auto", mb: 2, borderRadius: "50%", display: "grid", placeItems: "center", color: "#0877c9", bgcolor: "#eaf7ff" }}>
            <LockResetRoundedIcon sx={{ fontSize: 34 }} />
          </Box>
          <Typography component="h1" sx={{ fontWeight: 900, color: "#17394d", fontSize: { xs: "1.5rem", sm: "1.8rem" } }}>בחירת סיסמה חדשה</Typography>
          <Typography sx={{ color: "#647b8a", mt: 0.7, mb: 1.4 }}>בחר סיסמה חדשה לחשבון שלך.</Typography>
          <TextField
            margin="normal"
            required
            sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
            fullWidth
            name="password"
            label="סיסמה חדשה"
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.currentTarget.value)}
            autoComplete="current-password"
          />
          <Button
            variant="contained"
            sx={{ fontFamily: "inherit", width: "100%", py: 1.3, borderRadius: 3, fontWeight: 900 }}
            onClick={updatePassword}
          >
            עדכון הסיסמה
          </Button>
        </Box>
      )}
      {open && (
        <SimpleBackdrop
          open={open}
          setOpen={setOpen}
          handleClose={handleClose}
          handleToogle={handleToggle}
        />
      )}
      {next2 && (
        <Box>
          <Box sx={{ width: 62, height: 62, mx: "auto", mb: 2, borderRadius: "50%", display: "grid", placeItems: "center", color: "#178a61", bgcolor: "#eafaf4" }}>
            <VerifiedUserOutlinedIcon sx={{ fontSize: 34 }} />
          </Box>
          <Typography
            component="h1"
            sx={{ fontFamily: "inherit", fontWeight: 900, color: "#17394d", fontSize: { xs: "1.5rem", sm: "1.8rem" }, mb: 1.5 }}
          >
            הסיסמה עודכנה בהצלחה
          </Typography>
          <Typography sx={{ color: "#647b8a", mb: 2 }}>אפשר לחזור לחשבון ולהמשיך למכרז.</Typography>
          <Button component={NavLink} to="/signin" variant="contained" fullWidth sx={{ py: 1.3, borderRadius: 3, fontWeight: 900 }}>
            התחברות לחשבון
          </Button>
        </Box>
      )}
      </Paper>
    </Box>
  );
}

export default ForgotPassword;
